import React from 'react'
import useSWR from 'swr'
import Fetcher from 'lib/fetcher'
import NodeListItem from './item'

const NodeList = () => {
  const { data: nodes, mutate } = useSWR('nodes', Fetcher)

  return (
    <div className="flex flex-col">
      <div className="font-semibold">Nodes available to manage</div>
      {nodes && nodes?.length > 0 ? (
        <div className="flex flex-col space-y-2 py-2">
          {nodes.map((node) => (
            <NodeListItem key={node.id} node={node} mutate={mutate} />
          ))}
        </div>
      ) : nodes ? (
        <div>You have no nodes available to manage</div>
      ) : (
        <span>loading...</span>
      )}
    </div>
  )
}

export default NodeList
